
import React, { useState } from 'react';
import PageBox from '../../components/PageBox';
import ProTitle from '../../components/ProTitle';
import { Anchor } from 'antd';
import './index.less'
import valuebg1 from "../../static/images/valuebg1.png"
import valuebg2 from "../../static/images/valuebg2.png"
import valuebg3 from "../../static/images/valuebg3.png"
import valuebg5 from "../../static/images/valuebg5.png"
import valuebg6 from "../../static/images/valuebg6.png"
export default function App() {
  const memo = ''
  const memob =''
  const item =[
    {title:'行业知识库', key:'part-1', href:'#part-1',},
    {title:'投标保函', key:'part-2', href:'#part-2',},
    {title:'订单融资', key:'part-3', href:'#part-3',},
    {title:'履约保函', key:'part-4', href:'#part-4',},
    {title:'领域数据治理', key:'part-5', href:'#part-5',},
    {title:'云对象存储', key:'part-6', href:'#part-6',},
  ]
  const [top, setTop] = useState(70);
  return (
    <>
      <PageBox useBanner={true}>
        <div className='valueBanner'></div>
        <ProTitle name={'增值赋能服务'} memo={memo} />
        <div className='aimodel'>
          <Anchor offsetTop={top} direction="horizontal" items={item} />
        </div>
        <div className='huisebg' id="part-1">
          <div className='valueBox'>
            <div><img src={valuebg1} /></div>
            <div className='context' style={{width:'65%',paddingTop:'40px'}}>
              <h3>行业知识库</h3>
              <p>招采智库，合规随行</p>
              <div className='text'>实现了智能客服问答功能，可实时调用平台知识库信息，为用户提供专业、精准的答复；实现合规性及负面清单的标识比对。</div>
              <ul className='zhishiku'>
                <li>
                  <h3>负面清单的智能导入与管理</h3>
                  <p>系统支持灵活导入负面清单（如法律法规禁止项、行业限制条款等），并基于规则引擎实现清单的动态扩展与维护。同时支持清单分类管理，满足不同采购场景的差异化管控需求</p>
                </li>
                <li className='list'>
                  <h3>实时预警与负面清单自动识别</h3>
                  <p>系统依托规则引擎对文本内容进行实时扫描与语义分析，精准识别需求描述中涉及的负面清单条目。一旦检测到违规内容，系统立即触发实时预警机制，提示审核人员</p>
                </li>
                <li>
                  <h3>合规性审核与风险高亮提示</h3>
                  <p>系统自动将识别出的负面清单违规内容以可视化方式高亮标注，明确展示具体条款、违规依据及风险等级。审核人员可通过交互界面快速定位问题点，结合系统内置法律条文解读和处置建议完成决策</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='baise' id="part-2">
          <div className='valueBox'>
            <div className='context'>
              <h3>投标保函</h3>
              <p>出函快、有保障</p>
              <div className='text'>为保障招投标双方权益的核心金融支持服务，由银行或专业担保机构应投标人申请出具。它帮助投标人减少现金占用，降低资金压力。服务全程可在线申请、审核与出具，支持快速核验保函真伪，助力招投标流程合规高效推进</div>
            </div>
            <div><img src={valuebg2} /></div>
          </div>
        </div>
        <div className='huisebg'  id="part-3">
          <div className='valueBox'>
            <div style={{width:'30%'}}><img src={valuebg3} /></div>
            <div className='context'>
              <h3>订单融资</h3>
              <p>出函快、有保障</p>
              <div className='text'>订单融资服务是为用户解决供应链资金周转难题的专项金融服务，用户可凭真实订单向金融机构申请融资，无需额外提供足额抵押或担保，资金直接用于原材料采购、生产备货等订单履约环节。服务支持在线申请、快速审批，能有效缩短融资周期、缓解资金占用压力，帮助用户顺利完成订单交付，提升供应链响应效率与业务承接能力</div>
            </div>
          </div>
        </div>
        <div className='baise' id="part-4">
          <div className='valueBox'>
            <div className='context'>
              <h3>履约保函</h3>
              <p>出函快、有保障</p>
              <div className='text'>履约保函是银行等金融机构出具的担保凭证，核心为保障合同履约。该服务能降低交易双方履约风险，增强合作信任，还能帮申请人省去大额履约保证金，优化资金占用。其适用范围广，涵盖工程建设、贸易合作、服务合作等多类场景，为各类合同执行保驾护航</div>
            </div>
            <div className='lvyue'></div>
          </div>
        </div>
        <div className='huisebg' id="part-5">
          <div className='valueBox'>
            <div><img src={valuebg5} /></div>
            <div className='context'>
              <h3>领域数据治理</h3>
              <p>数据安全与合规</p>
              <div className='text'>
                <p>领域数据治理服务聚焦特定业务领域，通过梳理数据资产、规范数据标准、优化数据质量，解决数据孤岛、不一致、低质量等问题。</p>
                <p>服务围绕数据全生命周期，提供数据清洗、整合、安全管控及价值挖掘，助力用户构建高质量领域数据体系，为业务决策、流程优化提供可靠数据支撑，同时满足合规要求，释放数据在特定领域的核心价值。</p></div>
            </div>
          </div>
        </div>
        <div className='baise'  id="part-6">
          <div className='valueBox' style={{height:'400px'}}>
            <div className='context' style={{width:'75%'}}>
              <h3>云对象存储</h3>
              <p>突破传统存储，可靠安全</p>
              <div className='text'>云对象存储是基于云架构的海量数据存储服务，以 “对象” 为核心存储单元，包含数据本身、元数据及唯一标识符，摆脱传统文件目录层级限制</div>
              <ul className='cloudSave'>
                <li>
                  <h3>智能存储与弹性扩容</h3>
                  <p>支持TB级甚至PB级大容量存储，可轻松承载开标视频、工程图纸等超大文件；基于云原生架构，存储容量可根据项目数量动态扩展，无需提前采购硬件设备，扩容过程不影响业务正常运行，满足招采旺季的存储需求</p>
                </li>
                <li className='list'>
                  <h3>安全合规、快速调取</h3>
                  <p>招采项目资料需长期留存（通常10-15年），传统存储介质极易损坏，且无法快速关联项目全流程数据，给合规审计带来极大挑战。云对象存储采用专业储优化技术，确保音视频、文件无损压缩与存储，可实现文件秒级调取，避免传统存储中视频加载卡顿的问题</p>
                </li>
                <li>
                  <h3>精细化协作与权限管控</h3>
                  <p>可按照人员类型细化文件操作权限（如上传、下载、查看、编辑、批注、只读）。支持自动保留历史查询记录，同时，文件流转过程中可设置审批节点，实现“提交-审核-发布”的流程化管理</p>
                </li>
              </ul>
            </div>
            <div><img src={valuebg6} /></div>
          </div>
        </div>
      </PageBox>
    </>
    
  );
}
